import type { RecycleEvent, RecycleEventsResponse } from '../types/recycleEvents'

export const fetchRecycleEvents = async (options?: {
  limit?: number
  sinceId?: number
}): Promise<RecycleEventsResponse> => {
  const params = new URLSearchParams()
  params.set('limit', String(options?.limit ?? 20))
  if (options?.sinceId != null && options.sinceId > 0) {
    params.set('sinceId', String(options.sinceId))
  }

  const response = await fetch(`/api/recycle/events?${params.toString()}`, {
    headers: { Accept: 'application/json' }
  })

  const bodyText = await response.text()
  if (!response.ok) {
    throw new Error(`Failed to load recycle events (${response.status})`)
  }

  const json = JSON.parse(bodyText) as RecycleEventsResponse
  if (!Array.isArray(json.events)) {
    throw new Error('Invalid recycle events response')
  }

  return json
}

export const shortTx = (txHash: string | null | undefined): string => {
  if (!txHash) return '—'
  const h = txHash.replace(/^0x/i, '')
  if (h.length <= 14) return h
  return `${h.slice(0, 8)}…${h.slice(-6)}`
}

export type { RecycleEvent }
